export default __webpack_public_path__ + "static/media/sort-up-down.d3cc4357.svg";